// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"bb3c0c63","101":"72cb4408","141":"ff37abe6","587":"1706da16","635":"44712b6e","721":"0fe81329","838":"d16f4b8c","868":"d675f9e9","938":"d51b56bd","952":"ed975bce"}[chunkId] + ".chunk.js";
};